import React from "react";
import { Theme, createStyles, withStyles, Avatar, Typography } from "@material-ui/core";

const styles = (theme: Theme) => createStyles({
    root: {
        borderColor: theme.palette.primary.contrastText,
        borderWidth: 1,
        borderStyle: "solid",
        color: theme.palette.primary.contrastText,
        height: theme.spacing(6),
        margin: theme.spacing(),
        width: theme.spacing(6),
    }
});

interface IUserAvatarProps {
    classes: {
        root: string;
    };
    user: AvatarUser;
}

interface AvatarUser {
   
    avatarUrl:  string;
    
    color: string;

    displayName: string;
}

class UserAvatar extends React.Component<IUserAvatarProps> {
    public render() {
    
        const { user } = this.props;

        const { root } = this.props.classes;
        
        return <Avatar className={root} 
                        src={user.avatarUrl} 
                        title={`${user.displayName})`}
                        style={{
                        backgroundColor: user.color,
                    }}>
                <Typography variant="button">
                    {this.getInitials(user)}
                </Typography>
        </Avatar>
    }

    private getInitials(user: AvatarUser) {
        var splits = user.displayName.split(' ');
        let initials = splits[0].substr(0, 1);
        if (splits.length > 1) {
            initials += splits[1].substr(0, 1);
        }
        return initials;
    }
}

export default withStyles(styles)(UserAvatar);

